import Immutable from 'seamless-immutable';

import * as types from '../constants/actionTypes';
import initialState from './initialState';

export default (state = initialState.foldersReducer, action) => {
  const { payload } = action;

  switch (action.type) {
    case types.ADD_CONVERSATION_TO_FOLDER_REQUEST:
      return state.set('isLoading', true).set('behavior', 'ADD_CONVERSATION_TO_FOLDER');
    case types.ADD_CONVERSATION_TO_FOLDER_FAILURE:
      return state.set('isLoading', false).set('isError', true);
    case types.ADD_CONVERSATION_TO_FOLDER_SUCCESS:
      return state
        .set('isLoading', false)
        .set('isError', false)
        .set(
          'items',
          state.items.map(folder => {
            if (folder.id === payload.folderId) {
              return {
                ...folder,
                conversationCount: parseInt(folder.conversationCount) + 1,
              };
            }

            return folder;
          })
        );
    case types.REMOVE_CONVERSATION_FROM_FOLDER_REQUEST:
      return state.set('isLoading', true).set('behavior', 'REMOVE_CONVERSATION_FROM_FOLDER');
    case types.REMOVE_CONVERSATION_FROM_FOLDER_FAILURE:
      return state.set('isLoading', false).set('isError', true);

    case types.REMOVE_CONVERSATION_FROM_FOLDER_SUCCESS: {
      const folderSelected = { ...state.folderSelected };
      const folderConverstionCount = parseInt(folderSelected.conversationCount);
      if (folderSelected.id === payload.folderId) {
        folderSelected.conversationCount = folderConverstionCount - 1;
      }
      return state
        .set('isLoading', false)
        .set('isError', false)
        .set('folderSelected', folderSelected)
        .set(
          'items',
          state.items.map(folder => {
            if (folder.id === payload.folderId) {
              return {
                ...folder,
                conversationCount: folder.conversationCount > 0 ? folder.conversationCount - 1 : 0,
              };
            }
            return folder;
          })
        );
    }
    case types.GET_FOLDERS_REQUEST:
      return state.set('isLoading', true).set('behavior', 'GET');
    case types.GET_FOLDERS_FAILURE:
      return state.set('isLoading', false).set('isError', true);
    case types.GET_FOLDERS_SUCCESS:
      return state
        .set('isAlreadyGetSuccess', true)
        .set('isLoading', false)
        .set('isError', false)
        .set('data', payload.data)
        .set(
          'items',
          payload.items.sort((a, b) => {
            return b.id - a.id;
          })
        );
    // case types.ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER_REQUEST:
    //   return state
    //     .set('isLoading', true)
    //     .set('behavior', 'ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER');
    // case types.ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER_FAILURE:
    //   return state
    //     .set('isLoading', false)
    //     .set('isError', true);
    // case types.ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER_SUCCESS:
    //   return state
    //     .set('isLoading', false)
    //     .set('isError', false);
    case types.CREATE_FOLDER_REQUEST:
      return state.set('isLoading', true).set('behavior', 'CREATE');
    case types.CREATE_FOLDER_FAILURE:
      return state.set('isLoading', false).set('isError', true);
    case types.CREATE_FOLDER_SUCCESS:
      return state
        .set('isLoading', false)
        .set('isError', false)
        .set(
          'items',
          [...state.items, payload.item].sort((a, b) => {
            return b.id - a.id;
          })
        );

    case types.UPDATE_FOLDER_REQUEST:
      return state.set('isLoading', true).set('behavior', 'UPDATE');
    case types.UPDATE_FOLDER_FAILURE:
      return state.set('isLoading', false).set('isError', true);
    case types.UPDATE_FOLDER_SUCCESS:
      state = state
        .set('isLoading', false)
        .set('isError', false)
        .set(
          'items',
          state.items.map(item => {
            if (item.id === payload.item.id) {
              return payload.item;
            }
            return item;
          })
        );
      if (state.folderSelected?.id === payload.item.id) {
        state = state.set('folderSelected', payload.item);
      }
      return state;
    case types.DELETE_FOLDER_REQUEST:
      return state.set('isLoading', true).set('behavior', 'DELETE');
    case types.DELETE_FOLDER_FAILURE:
      return state.set('isLoading', false).set('isError', true);
    case types.DELETE_FOLDER_SUCCESS:
      return state
        .set('isLoading', false)
        .set('isError', false)
        .set(
          'items',
          state.items.filter(item => {
            if (item.id === payload.id) {
              return false;
            }

            return true;
          })
        );
    case types.DELETE_CONVERSATION_SUCCESS: {
      return state.set('items', action.data.newFolderItems);
    }
    case types.SELECT_FOLDER_SUCCESS:
      return state.set('folderSelected', action.folder);
    case types.END_GROUP_CHAT_SUCCESS:
      const { roomJid, data } = action.params;
      const { items } = Immutable.asMutable(state);
      const conversationSelected = data.find(c => c.peerVcard.xmppId === roomJid);
      let newFolderItems = items;

      if (conversationSelected) {
        const { folders } = conversationSelected;

        if (folders && Array.isArray(folders)) {
          newFolderItems = items.map(i => {
            const newItem = { ...i };
            if (folders.includes(newItem.id)) {
              newItem.conversationCount = parseInt(newItem.conversationCount) - 1;
            }
            return newItem;
          });
        }
      }

      return state.set('items', newFolderItems);
    default:
      return state;
  }
};
